import { TFunction } from 'i18next';
import { ActionsField } from './columns';
import { DataTableMeta } from '@otp/ui';
import { VideoResourceItem } from '../types';

export const getTableConfig = (
  videos: VideoResourceItem[],
  {
    t,
    onChange,
    onDelete,
  }: {
    t: TFunction;
    onChange: (
      updatedItem: VideoResourceItem,
      { description }: { description: string },
    ) => void;
    onDelete: (item: VideoResourceItem) => void;
  },
) => {
  return [
    {
      name: 'description',
      label: t('common.description'),
      options: {
        customBodyRender: (description: string) => {
          return <div dangerouslySetInnerHTML={{ __html: description }} />;
        },
      },
    },
    {
      name: 'isUploading',
      label: t('common.status.label'),
      options: {
        customBodyRender: (isUploading: boolean) => {
          return isUploading
            ? t('resources.form.fields.uploading')
            : t('resources.form.fields.uploaded');
        },
      },
    },
    {
      name: 'actions',
      label: t('common.actions'),
      options: {
        customBodyRender: (_: any, column: DataTableMeta) => {
          const video = videos[column.rowIndex];

          if (!video) {
            return null;
          }

          return (
            <ActionsField
              video={video}
              onDelete={onDelete}
              onChange={onChange}
            />
          );
        },
      },
    },
  ];
};
